export interface Folder {
  id: string;
  isFolder: boolean;
  userId: string;
  folderType: FolderType;
  title: string;
  isOpen?: boolean;
  date: number;
  isEditing?: boolean;
  isInfoOpen?: boolean;
  sortId?: number;
  thumbnail?: string;
  files?: string[];
  folderId?: string;
  orderId: number;
  mnemonic?: string;
  isShared?: boolean;
}

export enum FolderType {
  contact = 'contact',
  media = 'media',
  settings = 'settings',
  encoder = 'encoder',
  editor = 'editor',
  database = 'database',
  auction = 'auction',
  shop = 'shop',
}

export interface FolderRes {
  docs: Folder[];
}
